module.exports = __webpack_public_path__ + "static/media/20ECE26.096a411f.jpg";